import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import TrialPopup from './components/TrialPopup';
import ModernAlertHost from './components/ModernAlertHost';
import SessionIdleWatcher from './components/SessionIdleWatcher';
import SessionTimeoutModal from './components/SessionTimeoutModal';
import { TrialProvider } from './context/TrialContext';
import { UserProvider } from './context/UserContext';
import { permissionService } from './services/permissionService';
import { installNaturalsPortalFetchInterceptor } from '../admin-shared/patchPortalFetch';
import { API_BASE, PORTAL_ID } from './utils/api';
import { applyThemeToDocument, getStoredTheme } from './utils/theme';

import './assets/fonts/local-fonts.css';
import './index.css';

export default function SalonAdminFlowLayout() {
  useEffect(() => {
    applyThemeToDocument(getStoredTheme());
  }, []);

  useEffect(() => installNaturalsPortalFetchInterceptor(PORTAL_ID, API_BASE), []);

  // Franchise partners keep the dashboard open for check-ins — no idle auto-logout.
  const enableIdleTimeout = !permissionService.isFranchise();

  return (
    <UserProvider>
      <TrialProvider>
        <TrialPopup />
        <ModernAlertHost />
        {enableIdleTimeout ? (
          <>
            <SessionIdleWatcher />
            <SessionTimeoutModal />
          </>
        ) : null}
        <Outlet />
      </TrialProvider>
    </UserProvider>
  );
}
